import axios from "axios";

const axiosInstance = axios.create({
  //baseURL: "http://localhost:3001",
  //baseURL: 'http://127.0.0.1:8000', // Set the base URL for all requests
	baseURL: 'http://125.213.130.239:5006', // Set the base URL for all requests
  //timeout: 10000, // Optional: set a timeout for requests
  headers: {
    "Content-Type": "application/json",
    // Add other headers if needed
  },
});

export const fileUploadaxiosInstance = axios.create({
  //baseURL: "http://localhost:3001",
  //baseURL: 'http://127.0.0.1:8000', // Set the base URL for all requests
	baseURL: 'http://125.213.130.239:5006', // Set the base URL for all requests
  //timeout: 10000, // Optional: set a timeout for requests
  headers: {
    "Content-Type": "multipart/form-data",
    // Add other headers if needed
  },
});

export default axiosInstance;

